import React from "react";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import SalesNavBar from "../components/navbar/SalesNavbar";

const SalesLayout = () => (
  <DashboardLayout layout="/sales" Navbar={SalesNavBar} />
);

export default SalesLayout;
